"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubMenuItem = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var classnames_1 = require("../util/classnames");
var vdl_prefix_1 = require("../util/vdl-prefix");
var chevron_right_1 = __importDefault(require("adp-react-icons/lib/fa/chevron-right"));
var SubMenuItem = /** @class */function (_super) {
  __extends(SubMenuItem, _super);
  function SubMenuItem() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.handleOnClick = function () {
      var _a = _this.props,
        onClick = _a.onClick,
        config = _a.config;
      if (onClick) {
        onClick(config);
      }
    };
    return _this;
  }
  SubMenuItem.prototype.render = function () {
    var _a;
    var _b = this.props,
      className = _b.className,
      config = _b.config,
      active = _b.active;
    var submenuItemClasses = (_a = {}, _a[vdl_prefix_1.vdlPrefix('mega-menu-popover__submenu-item')] = true, _a[vdl_prefix_1.vdlPrefix('mega-menu-popover__submenu-item--active')] = active, _a);
    return react_1.default.createElement("li", {
      className: classnames_1.classNames(className, submenuItemClasses),
      onClick: this.handleOnClick
    }, active && react_1.default.createElement(chevron_right_1.default, {
      className: vdl_prefix_1.vdlPrefix('mega-menu-popover__submenu-item__active_indicator')
    }), config.title);
  };
  SubMenuItem.propTypes = {
    className: prop_types_1.default.string,
    onClick: prop_types_1.default.func.isRequired,
    config: prop_types_1.default.object.isRequired,
    active: prop_types_1.default.bool
  };
  return SubMenuItem;
}(react_1.default.Component);
exports.SubMenuItem = SubMenuItem;